<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showDynamicFieldModal" :data="model" :title="label" @show="onShow" size="sm"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <input-widget :label="false" :model="model" attribute="field" :type="type" autofocus/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import DynamicFieldForm from "../../../models/DynamicFieldForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "DynamicFieldModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new DynamicFieldForm(),
        showConfirmation: false,
        type: 'text',
        label: ''
      }
    },
    computed: {
      ...mapState({
        showDynamicFieldModal: state => state.termsData.showDynamicFieldModal,
        dynamicFieldName: state => state.termsData.dynamicFieldName,
        dynamicFields: state => state.customer.term.dynamic_fields
      }),
      ...globalMapState(['currentBranch'])
    },
    methods: {
      ...mapActions(['toggleDynamicFieldModal', 'updateCustomerTermsDynamicFields']),
      async onSubmit() {
        this.loading = true;
        let response = await this.updateCustomerTermsDynamicFields({
          key: this.dynamicFieldName,
          value: this.model.field
        });
        this.loading = false;
        if (response.success) {
          this.$toast('success', this.$t('updated successfully'));
          this.showConfirmation = false;
          if (!this.dynamicFields[this.currentBranch.uuid]) {
            this.dynamicFields[this.currentBranch.uuid] = {};
          }
          this.dynamicFields[this.currentBranch.uuid][this.dynamicFieldName] = this.model.field;
          this.toggleDynamicFieldModal(false);
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        if (this.currentBranch.customer_terms_dynamic_fields_template) {
          if (this.currentBranch.customer_terms_dynamic_fields_template[this.dynamicFieldName]) {
            this.type = this.currentBranch.customer_terms_dynamic_fields_template[this.dynamicFieldName]['type'];
            this.label = this.currentBranch.customer_terms_dynamic_fields_template[this.dynamicFieldName]['label'];
          }
        }
        let value;
        if (this.dynamicFields[this.currentBranch.uuid]) {
          value = this.dynamicFields[this.currentBranch.uuid][this.dynamicFieldName];
        }
        this.model = new DynamicFieldForm({field: value});
      },
      onHidden() {
        this.model = new DynamicFieldForm();
        this.toggleDynamicFieldModal(false);
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
